import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';
import { translate } from '@openclassrooms/translations';
import { StudentApplication } from '@openclassrooms/sdk-web';
import Card from '@classify/react-core-components/Card';
import Typography from '@classify/react-core-components/Typography';
import Button from '@classify/react-core-components/Button';
import Stack from '@classify/react-core-components/Stack';
import CopyContent from '@classify/react-core-components/CopyContent';
import { ContactElement, CopyWrapper } from './ContactElements';
import { ContactContext } from './ContactButton/ContactProvider';
import { formatTimeWithClock } from './ContactButton/PagePhone';
interface Props {
  shouldDisplayPrimaryActionButton?: boolean;
  onContactClick?: () => void;
  contact?: StudentApplication['owner'];
  supportChannel?: StudentApplication['supportChannel'];
}
const CARD_MAX_WIDTH = 656;
const CTA_BUTTON_WIDTH = 300;
export const APLOwnerContactCard = t0 => {
  const $ = _c(80);
  const {
    contact,
    supportChannel,
    shouldDisplayPrimaryActionButton,
    onContactClick
  } = t0;
  let t1;
  if ($[0] !== contact) {
    t1 = contact ?? {};
    $[0] = contact;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    name,
    calendarLink,
    phoneNumber,
    email
  } = t1;
  const {
    getLocalisationConfig
  } = useLocalisationConfig();
  const contactContext = useContext(ContactContext);
  let t2;
  if ($[2] !== getLocalisationConfig) {
    t2 = getLocalisationConfig("hoursFormat24");
    $[2] = getLocalisationConfig;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const is24HoursFormat = Boolean(t2);
  let t3;
  if ($[4] !== getLocalisationConfig) {
    t3 = getLocalisationConfig("contact.phone.officeHours");
    $[4] = getLocalisationConfig;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const officeHours = t3 as string;
  let T0;
  let T1;
  let T2;
  let T3;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] !== calendarLink || $[7] !== contactContext || $[8] !== email || $[9] !== is24HoursFormat || $[10] !== name || $[11] !== officeHours || $[12] !== onContactClick || $[13] !== phoneNumber || $[14] !== shouldDisplayPrimaryActionButton || $[15] !== supportChannel) {
    const [, openingTime, closingTime, timeZone] = String(officeHours).split("|");
    const shouldDisplayOwnerEmail = supportChannel === "email" && Boolean(email);
    let t19;
    if ($[35] !== contactContext || $[36] !== email || $[37] !== onContactClick || $[38] !== supportChannel) {
      t19 = () => {
        onContactClick?.();
        contactContext?.openEmail(supportChannel === "case" ? email : undefined);
      };
      $[35] = contactContext;
      $[36] = email;
      $[37] = onContactClick;
      $[38] = supportChannel;
      $[39] = t19;
    } else {
      t19 = $[39];
    }
    const handleContactClick = t19;
    T3 = Card;
    if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = {
        maxWidth: CARD_MAX_WIDTH
      };
      $[40] = t18;
    } else {
      t18 = $[40];
    }
    T2 = Stack;
    t13 = "flex-start";
    t14 = 1;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = {
        px: 4,
        py: 2
      };
      $[41] = t15;
    } else {
      t15 = $[41];
    }
    t16 = "column";
    if ($[42] !== name) {
      t17 = <Typography variant="h4">{name}</Typography>;
      $[42] = name;
      $[43] = t17;
    } else {
      t17 = $[43];
    }
    T1 = Stack;
    t6 = "stretch";
    t7 = 2;
    t8 = "column";
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = {
        width: CTA_BUTTON_WIDTH
      };
      $[44] = t9;
    } else {
      t9 = $[44];
    }
    if ($[45] !== phoneNumber) {
      t10 = phoneNumber && <ContactElement sx={{
        border: "none",
        pt: 0,
        svg: {
          fontSize: 24
        }
      }}><LocalPhoneIcon /><CopyWrapper><CopyContent shouldUseIcon={true} translations={{
            copyButtonLabel: translate("global.word.copy_phone"),
            copyFailed: translate("global.error.general_error"),
            copySuccess: translate("global.snackbar.link_copied")
          }}>{phoneNumber}</CopyContent></CopyWrapper></ContactElement>;
      $[45] = phoneNumber;
      $[46] = t10;
    } else {
      t10 = $[46];
    }
    if ($[47] !== email || $[48] !== handleContactClick || $[49] !== shouldDisplayOwnerEmail) {
      t11 = shouldDisplayOwnerEmail ? <ContactElement sx={{
        border: "none",
        pt: 0,
        svg: {
          fontSize: 24
        }
      }}><MailOutlinedIcon /><CopyWrapper><CopyContent shouldUseIcon={true} translations={{
            copyButtonLabel: translate("global.word.copy_mail"),
            copyFailed: translate("global.error.general_error"),
            copySuccess: translate("global.snackbar.link_copied")
          }}>{`${email}`}</CopyContent></CopyWrapper></ContactElement> : <Button startIcon={<MailOutlinedIcon />} variant="secondary" onClick={handleContactClick}>{translate("contact.apl_owner.contact_cta.label")}</Button>;
      $[47] = email;
      $[48] = handleContactClick;
      $[49] = shouldDisplayOwnerEmail;
      $[50] = t11;
    } else {
      t11 = $[50];
    }
    if ($[51] !== calendarLink || $[52] !== shouldDisplayPrimaryActionButton) {
      t12 = calendarLink && <Button startIcon={<EventAvailableIcon />} endIcon={<OpenInNewIcon />} variant={shouldDisplayPrimaryActionButton ? "primary" : "secondary"} href={calendarLink} component="a" target="_blank">{translate("contact.apl_owner.appointment_cta.label")}</Button>;
      $[51] = calendarLink;
      $[52] = shouldDisplayPrimaryActionButton;
      $[53] = t12;
    } else {
      t12 = $[53];
    }
    T0 = Typography;
    t4 = "caption";
    t5 = translate("contact.apl_owner.opening_hours", {
      opening_time: formatTimeWithClock(openingTime, is24HoursFormat),
      closing_time: formatTimeWithClock(closingTime, is24HoursFormat),
      timezone: timeZone
    });
    $[6] = calendarLink;
    $[7] = contactContext;
    $[8] = email;
    $[9] = is24HoursFormat;
    $[10] = name;
    $[11] = officeHours;
    $[12] = onContactClick;
    $[13] = phoneNumber;
    $[14] = shouldDisplayPrimaryActionButton;
    $[15] = supportChannel;
    $[16] = T0;
    $[17] = T1;
    $[18] = T2;
    $[19] = T3;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
    $[28] = t18;
    $[29] = t4;
    $[30] = t5;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
  } else {
    T0 = $[16];
    T1 = $[17];
    T2 = $[18];
    T3 = $[19];
    t10 = $[20];
    t11 = $[21];
    t12 = $[22];
    t13 = $[23];
    t14 = $[24];
    t15 = $[25];
    t16 = $[26];
    t17 = $[27];
    t18 = $[28];
    t4 = $[29];
    t5 = $[30];
    t6 = $[31];
    t7 = $[32];
    t8 = $[33];
    t9 = $[34];
  }
  let t19;
  if ($[54] !== T0 || $[55] !== t4 || $[56] !== t5) {
    t19 = <T0 variant={t4}>{t5}</T0>;
    $[54] = T0;
    $[55] = t4;
    $[56] = t5;
    $[57] = t19;
  } else {
    t19 = $[57];
  }
  let t20;
  if ($[58] !== T1 || $[59] !== t10 || $[60] !== t11 || $[61] !== t12 || $[62] !== t19 || $[63] !== t6 || $[64] !== t7 || $[65] !== t8 || $[66] !== t9) {
    t20 = <T1 alignItems={t6} gap={t7} direction={t8} sx={t9}>{t10}{t11}{t12}{t19}</T1>;
    $[58] = T1;
    $[59] = t10;
    $[60] = t11;
    $[61] = t12;
    $[62] = t19;
    $[63] = t6;
    $[64] = t7;
    $[65] = t8;
    $[66] = t9;
    $[67] = t20;
  } else {
    t20 = $[67];
  }
  let t21;
  if ($[68] !== T2 || $[69] !== t13 || $[70] !== t14 || $[71] !== t15 || $[72] !== t16 || $[73] !== t17 || $[74] !== t20) {
    t21 = <T2 alignItems={t13} gap={t14} sx={t15} direction={t16}>{t17}{t20}</T2>;
    $[68] = T2;
    $[69] = t13;
    $[70] = t14;
    $[71] = t15;
    $[72] = t16;
    $[73] = t17;
    $[74] = t20;
    $[75] = t21;
  } else {
    t21 = $[75];
  }
  let t22;
  if ($[76] !== T3 || $[77] !== t18 || $[78] !== t21) {
    t22 = <T3 sx={t18}>{t21}</T3>;
    $[76] = T3;
    $[77] = t18;
    $[78] = t21;
    $[79] = t22;
  } else {
    t22 = $[79];
  }
  return t22;
};